// frontend/app/src/features/feedback/ui/forms/ApplicationForm.jsx
import React, { useState } from 'react';
import { feedbackApi } from '../../api/feedback.api';

const ApplicationForm = ({ onSuccess }) => {
  const [appType, setAppType] = useState('rating');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const [ratingData, setRatingData] = useState({
    streamer_name: '',
    stream_platform: 'twitch',
    stream_url: '',
    experience: '',
  });

  const [positionData, setPositionData] = useState({
    position: 'moderator',
    motivation: '',
    skills: '',
    available_hours: '',
  });

  const handleRatingChange = (e) => {
    const { name, value } = e.target;
    setRatingData(prev => ({ ...prev, [name]: value }));
  };

  const handlePositionChange = (e) => {
    const { name, value } = e.target;
    setPositionData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      if (appType === 'rating') {
        await feedbackApi.submitRatingApplication(ratingData);
      } else {
        await feedbackApi.submitPositionApplication(positionData);
      }
      setStatus({ type: 'success', message: 'ЗАЯВКА УСПЕШНО ОТПРАВЛЕНА! МЫ СВЯЖЕМСЯ С ВАМИ.' });
      if (onSuccess) setTimeout(onSuccess, 2000);
    } catch (error) {
      const serverError = error.response?.data;
      let errorMsg = 'ОШИБКА ОТПРАВКИ. ПОПРОБУЙТЕ ПОЗЖЕ.';
      
      if (serverError) {
        if (typeof serverError === 'object') {
          errorMsg = Object.entries(serverError)
            .map(([field, msgs]) => `${field.toUpperCase()}: ${Array.isArray(msgs) ? msgs.join(' ') : msgs}`)
            .join(' | ');
        } else if (typeof serverError === 'string') {
          errorMsg = serverError;
        }
      }
      
      setStatus({ type: 'error', message: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="feedback-form">
      <div className="application-type-selector">
        <label className="app-type-radio">
          <input
            type="radio"
            name="appType"
            value="rating"
            checked={appType === 'rating'}
            onChange={() => setAppType('rating')}
          />
          В РЕЙТИНГ
        </label>
        <label className="app-type-radio">
          <input
            type="radio"
            name="appType"
            value="position"
            checked={appType === 'position'}
            onChange={() => setAppType('position')}
          />
          НА ДОЛЖНОСТЬ
        </label>
      </div>

      {appType === 'rating' ? (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div className="form-group">
              <label>ИМЯ СТРИМЕРА</label>
              <input
                name="streamer_name"
                value={ratingData.streamer_name}
                onChange={handleRatingChange}
                placeholder="ВАШ НИК"
                required
              />
            </div>
            <div className="form-group">
              <label>ПЛАТФОРМА</label>
              <select name="stream_platform" value={ratingData.stream_platform} onChange={handleRatingChange}>
                <option value="twitch">TWITCH</option>
                <option value="youtube">YOUTUBE</option>
                <option value="goodgame">GOODGAME</option>
                <option value="vk_play">VK PLAY</option>
                <option value="other">ДРУГОЕ</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>ССЫЛКА НА КАНАЛ</label>
            <input
              name="stream_url"
              value={ratingData.stream_url}
              onChange={handleRatingChange}
              placeholder="HTTPS://..."
              required
            />
          </div>
          <div className="form-group">
            <label>ОПЫТ В ИГРАХ</label>
            <textarea
              name="experience"
              value={ratingData.experience}
              onChange={handleRatingChange}
              placeholder="РАССКАЖИТЕ О ВАШЕМ ОПЫТЕ..."
              required
            />
          </div>
        </>
      ) : (
        <>
          <div className="form-group">
            <label>ЖЕЛАЕМАЯ ДОЛЖНОСТЬ</label>
            <select name="position" value={positionData.position} onChange={handlePositionChange}>
              <option value="moderator">МОДЕРАТОР</option>
              <option value="coordinator">КООРДИНАТОР</option>
              <option value="developer">РАЗРАБОТЧИК</option>
              <option value="content_maker">КОНТЕНТ-МЕЙКЕР</option>
              <option value="event_organizer">ОРГАНИЗАТОР</option>
            </select>
          </div>
          <div className="form-group">
            <label>МОТИВАЦИЯ</label>
            <textarea
              name="motivation"
              value={positionData.motivation}
              onChange={handlePositionChange}
              placeholder="ПОЧЕМУ ВЫ ХОТИТЕ В КОМАНДУ?"
              required
            />
          </div>
          <div className="form-group">
            <label>НАВЫКИ И ОПЫТ</label>
            <textarea
              name="skills"
              value={positionData.skills}
              onChange={handlePositionChange}
              placeholder="ЧТО ВЫ УМЕЕТЕ?"
              required
            />
          </div>
          <div className="form-group">
            <label>ДОСТУПНОЕ ВРЕМЯ (Ч/НЕД)</label>
            <input
              name="available_hours"
              value={positionData.available_hours}
              onChange={handlePositionChange}
              placeholder="НАПРИМЕР: 10-15 ЧАСОВ"
            />
          </div>
        </>
      )}

      <div className="feedback-form-actions">
        <button type="submit" className="feedback-submit-btn" disabled={loading}>
          {loading ? 'ОТПРАВКА...' : '📝 ОТПРАВИТЬ ЗАЯВКУ'}
        </button>
      </div>

      {status.message && (
        <div className={`feedback-status-msg ${status.type}`}>
          {status.message}
        </div>
      )}
    </form>
  );
};

export default ApplicationForm;
